import ProfileItem from './ProfileItem';

export default ProfileItem;
